// Registers the service worker that makes the app installable and offline-capable.
// Only runs in production builds served over a secure context (https or localhost);
// the dev server is left untouched so hot-reload and debugging are unaffected.

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return
  if (!('serviceWorker' in navigator)) return

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // Registration failure is non-fatal — the app still works online.
      console.warn('Service worker registration failed:', err)
    })
  })
}
